import React, { useMemo } from "react";
import { ParcelCenterContact } from "../../../app/models/responseModels/parcelCenterResponse";
import {
  MaterialReactTable,
  MRT_ColumnDef,
  useMaterialReactTable,
} from "material-react-table";
import { getDefaultMRTOptions } from "../../dedicatedDelivery/DefaultMrtOptions";
import { Grid, Typography } from "@mui/material";

type ParcelCenterContactsProps = {
  parcelCenterId: string;
  data: ParcelCenterContact[];
};
const ParcelCenterContacts: React.FC<ParcelCenterContactsProps> = ({
  parcelCenterId,
  data,
}) => {
  const defaultMRTOptions = getDefaultMRTOptions<ParcelCenterContact>();

  // Columns to be used on grid on landing page
  const columns = useMemo<MRT_ColumnDef<ParcelCenterContact>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
      },
      {
        header: "Parcel Center ID",
        Cell: ({ cell, row }) => parcelCenterId,
      },
      {
        accessorKey: "userId",
        header: "User ID",
      },
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "phone",
        header: "Phone Number",
      },
      {
        accessorKey: "deleted",
        header: "Is Deletd?",
      },
      {
        accessorKey: "createdOn",
        header: "Created On",
        size: 10,
        Cell: ({ cell, row }) => (
          <div>
            {row.original.createdOn ? (
              <span>
                {new Date(cell.getValue<string>()).toLocaleString("en-US", {
                  hourCycle: "h12",
                })}
              </span>
            ) : (
              <span></span>
            )}
          </div>
        ),
      },
      {
        accessorKey: "updatedOn",
        header: "Updated On",
        size: 10,
        Cell: ({ cell, row }) => (
          <div>
            {row.original.createdOn ? (
              <span>
                {new Date(cell.getValue<string>()).toLocaleString("en-US", {
                  hourCycle: "h12",
                })}
              </span>
            ) : (
              <span></span>
            )}
          </div>
        ),
      },
      {
        accessorKey: "createdBy",
        header: "Created By",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
      },
    ],
    [data]
  );

  // preprare MRT V2 grid
  const table = useMaterialReactTable({
    ...defaultMRTOptions,
    columns: columns,
    data: data,
    initialState: {
      ...defaultMRTOptions.initialState,
      columnVisibility: {
        id: true,
      },
      sorting: [{ desc: true, id: "id" }],
    },
    state: {
      showProgressBars: false,
      sorting: [{ desc: true, id: "id" }],
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (e) => {},
      ...defaultMRTOptions.muiTableBodyRowProps,
      sx: {
        cursor: "pointer",
      },
    }),
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderBottomToolbarCustomActions: () => {
      return (
        <Typography variant="subtitle2" component="p">
          Total Rows: {data.length}
        </Typography>
      );
    },
  });

  return (
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <MaterialReactTable table={table} />
    </Grid>
  );
};

export default ParcelCenterContacts;
